/**
 * Der Farbton einer Rubrik – für die Person, die gerade zusieht.
 *
 * Dieselbe Rubrik hat auf „Mein Tag", in der Angebotsliste und in der
 * Auftragsliste dieselbe Farbe (v14, 17.3). Wer sich seine Rubriken umfärbt
 * (v14, 13), findet die eigene Wahl überall wieder – sonst hieße „meine
 * Farben" nur „meine Farben auf einer Maske".
 *
 * Eine Stelle für die Auflösung, weil sie sonst dreimal dasteht und beim
 * nächsten Ton auseinanderläuft. Der Wächter ist Teil der Regel: Eine
 * gespeicherte Kennung, die es nicht mehr gibt, fällt stillschweigend auf
 * die Vorbelegung zurück und reißt nicht die Maske mit.
 */

import { useQuery } from '@tanstack/react-query';

import { api } from '../api';
import { useMeta } from '../zustand';
import type { Profil, Ton } from '../typen';

export type TonFuer = (rubrik: string) => Ton;

/**
 * Löst Rubrik → Ton auf, ohne React – für Stellen, die ihre Daten schon haben.
 */
export function tonAufloesen(
  rubrik: string,
  toene: Ton[],
  vorbelegung: Record<string, string>,
  gewaehlt: Record<string, string>,
): Ton {
  const gespeichert = gewaehlt[rubrik];
  const id = gespeichert && toene.some((t) => t.id === gespeichert) ? gespeichert : vorbelegung[rubrik];
  return toene.find((t) => t.id === id) ?? toene[0]!;
}

/**
 * Der Haken für Masken: liefert eine Funktion `ton('beschaffung')`.
 *
 * Das Profil ist dieselbe Abfrage wie im Farbpanel; React Query hält sie im
 * Zwischenspeicher, es entsteht also keine zweite Anfrage je Maske.
 */
export function useRubrikton(): TonFuer {
  const meta = useMeta();
  const profil = useQuery({ queryKey: ['profil'], queryFn: () => api.hole<Profil>('/profil') });
  const gewaehlt = profil.data?.rubrikfarben ?? {};
  return (rubrik: string) => tonAufloesen(rubrik, meta.toene, meta.rubrikTon, gewaehlt);
}
